import { useContext } from 'react';
import { VerificationUpsellModalStoreContext } from '../stores/VerificationUpsellModalStoreContext';

export default function useVerificationUpsellState() {
  return useContext(VerificationUpsellModalStoreContext);
}
